<template src="./user-not-found.html"></template>

<script>
export default {
  name: 'GondolaMiniUserNotFound',
};
</script>
